import { useEffect, useState } from "react";

// Matches Tailwind's `lg` breakpoint, which is what gates the bulk-entry
// entry point in AppShellLayout.tsx (`hidden lg:inline-flex`).
const DESKTOP_BREAKPOINT = 1024;

export const useIsDesktopViewport = (): boolean => {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= DESKTOP_BREAKPOINT
  );

  useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`);
    const onChange = () => setIsDesktop(window.innerWidth >= DESKTOP_BREAKPOINT);
    mql.addEventListener("change", onChange);
    onChange();
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isDesktop;
};
